export default __webpack_public_path__ + "static/media/no_data_found.a3e311dc.png";